// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-episode-card {
  max-width: 100%;
}
.select-episode-card .vjs-big-play-button {
  display: none;
}
.select-episode-card__cover {
  position: relative;
}
.select-episode-card__media-cover {
  padding-bottom: 56.25%;
  background-size: cover;
  background-color: #efefef;
  border-radius: var(--default-border-radius) var(--default-border-radius) 0px 0px;
}
.select-episode-card__status-tag {
  position: absolute;
  padding: 5px 10px;
  bottom: 12px;
  display: flex;
  align-items: center;
  left: 12px;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 600;
  background-color: #ecf0f1;
  color: #e74c3c;
  padding-left: 23px;
}
.select-episode-card__status-tag::before {
  position: absolute;
  content: "";
  width: 8px;
  height: 8px;
  left: 10px;
  border-radius: 100%;
  background-color: #e74c3c;
}`, "",{"version":3,"sources":["webpack://./src/components/functional/SelectEpisodeCard/SelectEpisodeCard.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;AACI;EACI,aAAA;AACR;AAEI;EACI,kBAAA;AAAR;AAGI;EACI,sBAAA;EACA,sBAAA;EACA,yBAAA;EACA,gFAAA;AADR;AAII;EACI,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;AAFR;AAIQ;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;AAFZ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
